// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__1znc3","topBottomGutter":"Layout_topBottomGutter__1vZ_l"};